import ajax from "plugins/AjaxService"
import { Folder } from "types/Recipe"

/**
"base"
puo' essere:
"recipes" | "crops" | "crops_recipes"
 */

const getIdFromBase = (base: string): string => ({ 
	"recipes": "recipesIds", 
	"crops": "cropsIds", 
	"crops_recipes": "cropsIds" 
}[base])

/**
 * INDEX 
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-60815
 */
function index(base: string): Promise<{ data: Folder[] }> {
	return ajax.get(`${base}/grouping_folders`)
}

/**
 * CREATE UPDATE
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-60795
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-60835
 */
function save(base: string, folder: Folder, ids?: number[]): Promise<{ data: Folder }> {
	// casomai ci fossero queste proprità non necessarie le elimino
	delete folder["recipes"]
	delete folder["crops"]

	// se ci sono elementi dentro il FOLDER li inserisce con il giusto nome di proprietà
	if (ids?.length > 0) {
		folder[getIdFromBase(base)] = ids
	}

	// crea/aggiorna il FOLDER
	if (!folder.id) {
		return ajax.post(`${base}/grouping_folders`, { grouping_folder: folder })
	} else {
		return ajax.put(`${base}/grouping_folders/${folder.id}`, { grouping_folder: folder })
	}
}

/**
 * DELETE
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-60855
  */
function destroy(base: string, id: number): Promise<void> {
	return ajax.delete(`${base}/grouping_folders/${id}`)
}

/**
 * BULK MOVE
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-60875
 */
function bulkMove(base: string, folderId: number, ids: number[]): Promise<void> {
	return ajax.post(
		`${base}/grouping_folders/bulk_move`,
		{
			grouping_folder: {
				id: folderId,
				[getIdFromBase(base)]: ids
			},
		}
	)
}

const foldersApi = {
	index,
	save,
	destroy,
	bulkMove,
}
export default foldersApi